export default __webpack_public_path__ + "static/media/Newshape.d0bd1298.png";